import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, TextInput, TextStyle, View } from 'react-native';

import FilterIcon from '../../../assets/social/filter.svg';
import SearchIcon from '../../../assets/social/search.svg';
import { Pressable } from '../common/Touchable';
import { SOCIAL_FONT, socialColors, socialGlow } from './socialTheme';

type WebInputStyle = TextStyle & {
	outlineStyle?: 'none';
};

type FriendsSearchRowProps = {
	value: string;
	onChangeText: (value: string) => void;
	onPressFilter?: () => void;
};

const FriendsSearchRow = ({ value, onChangeText, onPressFilter }: FriendsSearchRowProps) => {
	const { t } = useTranslation();

	return (
		<View style={styles.row}>
			<View style={styles.field}>
				<TextInput
					value={value}
					onChangeText={onChangeText}
					placeholder={t('T_SITE_A11Y_SEARCH_BY_USERNAME', { defaultValue: 'Search by username' })}
					placeholderTextColor={socialColors.placeholder}
					autoCapitalize='none'
					autoCorrect={false}
					style={styles.input}
				/>
			</View>

			<View style={styles.roundButton}>
				<SearchIcon width={19} height={19} />
			</View>

			<Pressable style={styles.roundButton} onPress={onPressFilter}>
				<FilterIcon width={18} height={18} />
			</Pressable>
		</View>
	);
};

const styles = StyleSheet.create({
	row: {
		flexDirection: 'row',
		alignItems: 'center',
		gap: 9,
	},
	field: {
		flex: 1,
		height: 46,
		borderRadius: 23,
		borderWidth: 1,
		borderColor: socialColors.borderOrange,
		backgroundColor: socialColors.plate,
		justifyContent: 'center',
		...socialGlow.searchField,
	},
	input: {
		paddingLeft: 18,
		paddingRight: 18,
		paddingTop: 0,
		paddingBottom: 0,
		color: socialColors.name,
		fontFamily: SOCIAL_FONT,
		fontSize: 15,
		fontWeight: '500',
		outlineStyle: 'none',
	} as WebInputStyle,
	roundButton: {
		width: 44,
		height: 44,
		borderRadius: 22,
		borderWidth: 1,
		borderColor: socialColors.borderYellow,
		backgroundColor: socialColors.plate,
		alignItems: 'center',
		justifyContent: 'center',
		...socialGlow.searchField,
	},
});

export default FriendsSearchRow;
